import React from 'react';
import MicroApp from '@/components/micro-app';
import env from '@/env';
import { LOCATION_EMBEDDED } from '../constants';
import { tbInMyCreate } from '../goto-tb';

// 商品组: #/product
// 广告组: #/advert
function Material(props: any) {
  // return null;
  const { data, ..._props } = props;

  return (
    <MicroApp
      data={{ ...tbInMyCreate, locationEmbedded: LOCATION_EMBEDDED, ...data }}
      {..._props}
      destory
      name="newtfmaterial"
      url={`${env.ACE_DOMAIN}/material`}
    />
  );
}

export default Material;
